import React, { useEffect, useState } from 'react';
import moment from 'moment';
import dayjs from 'dayjs';
import _, { cloneDeep } from 'lodash';
import { DatePicker, Form, Input, InputNumber, message, Row, Collapse } from 'antd';

import SelectComponent from '../Widgets/SelectComponent';
import TableView from '../Widgets/TableView';
import { dailyShift, morningShift, nightShift, defaultRange } from '../../Constants/index.js';

const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const FormWithSubTabs = (props) => {
  let [formObject, setFormObject] = useState(props.formObject.form || {});
  let [, setHeader] = useState(props.header || []);
  let [, setHeaderValue] = useState(props.headerValue || []);
  let [, setUserProfile] = useState(props.userProfile || {});
  const shift = 'daily';
  const newLocal = true;

  useEffect(() => {
    setFormObject(props.formObject);
    setHeader(props.header);
    setHeaderValue(props.headerValue);
    setUserProfile(props.userProfile);
  }, [props.formObject, props.formType]);

  const onInputHeaderMainChange = async (columnValue, columnKey) => {
    let formData = {
      ...formObject,
      mainHeaderValue: {
        ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
        [columnKey]: columnValue
      }
    };
    props.downTimeData(formData, false);
  };

  const onDateHeaderMainChange = (date, columnKey) => {
    let formData = {
        ...formObject,
        mainHeaderValue: {
          ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
          [columnKey]: dayjs(date).format('YYYY-MM-DD HH:mm:ss')        
      }
    };
    props.downTimeData(formData, false);

  };

  const disabledRangeTime = (current) => {
    if (
      current !== null &&
      formObject &&
      formObject['mainHeaderValue'] &&
      formObject['mainHeaderValue']['Date']
    ) {
      let selectedDate = moment(
        formObject && formObject['mainHeaderValue'] && formObject['mainHeaderValue']['Date']
      ).format('YYYY-MM-DD');
      let currentDate = moment(current).format('YYYY-MM-DD');
      let range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
          result.push(i);
        }
        return result;
      };
      if (shift === 'Morning Shift' && selectedDate === currentDate) {
        return {
          // disabledHours: () => range(18, 18),
          disabledHours: () => [0, 1, 2, 3, 4, 5, 18, 19, 20, 21, 22, 23],
          disabledMinutes: () => range(60, 60)
          // disabledSeconds: () => [55, 56],
        };
      } else if (shift === 'Night Shift' && selectedDate === currentDate) {
        return {
          disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
          disabledMinutes: () => range(60, 60)
        };
      } else if (shift === 'Night Shift' && selectedDate !== currentDate) {
        return {
          disabledHours: () => [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
          disabledMinutes: () => range(60, 60)
        };
      } else if (selectedDate === currentDate) {
        return {
          disabledHours: () => [0, 1, 2, 3, 4, 5],
          disabledMinutes: () => range(60, 60)
        };
      } else if (selectedDate !== currentDate) {
        return {
          disabledHours: () => [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
        };
      }
    }

    return {
      disabledHours: () => [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
      ]
    };
  };

  const disabledDatePicker = (formObject, current, showTime) => {
    if (
      formObject &&
      formObject['mainHeaderValue'] &&
      formObject['mainHeaderValue']['Date'] &&
      showTime
    ) {
      let selectedDate = moment(formObject['mainHeaderValue']['Date'], 'YYYY-MM-DD HH:mm:ss');
      return (
        current > moment(selectedDate).add(1, 'day').endOf('day') ||
        current < moment(selectedDate).startOf('day')
      );
    } else if (!showTime) {
      return current > moment().endOf('day');
    }
    return current || current > moment().endOf('day') || current < moment().startOf('day');
  };

  const onMainOk = (date, columnKey) => {
    let startDate2 = moment(date[0]).format('YYYY-MM-DD HH:mm');
    let endDate2 = moment(date[1]).format('YYYY-MM-DD HH:mm');
    if (date[0] !== null && date[1] !== null) {
      if (startDate2 === endDate2) {
        message.error('StartDateTime and EndDateTime should not be same');
        formObject = {
          ...formObject,
          mainHeaderValue: {
            ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
            [columnKey]: {
              // startDate: moment(date[0]).format("YYYY-MM-DD HH:mm:ss"),
              // endDate: moment(date[1]).format("YYYY-MM-DD HH:mm:ss"),
            }
          }
        };
        props.downTimeData(formObject, false);
      } else if (startDate2 !== endDate2) {
        startDate2 = moment(date[0]).format('YYYY-MM-DD HH:mm');
        endDate2 = moment(date[1]).format('YYYY-MM-DD HH:mm');
        formObject = {
          ...formObject,
          mainHeaderValue: {
            ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
            [columnKey]: {
              startDate: moment(date[0]).format('YYYY-MM-DD HH:mm'),
              endDate: moment(date[1]).format('YYYY-MM-DD HH:mm')
            }
          }
        };

        let masterData = [
          {
            shift: 'Morning Shift',
            startHour: '06',
            endHour: '17',
            startHour1: '06',
            endHour1: '23',
            startHour2: '00',
            endHour2: '05'
          },
          {
            shift: 'Night Shift',
            startHour: '18',
            endHour: '05',
            startHour1: '06',
            endHour1: '23',
            startHour2: '00',
            endHour2: '05'
          }
        ];

        let startTime = moment(date[0]).format('HH:mm');
        let startHours = moment(date[0]).format('HH');

        let endHours = moment(date[1]).format('HH');
        let startDate = moment(date[0]).format('DD');
        let endDate = moment(date[1]).format('DD');
        let endTime = moment(date[1]).format('HH:mm');
        let Shift =
          formObject && formObject['mainHeaderValue'] && formObject['mainHeaderValue']['Shift'];
        let selectedDate =
          formObject && formObject['mainHeaderValue'] && formObject['mainHeaderValue']['Date'];
        let currentDate = moment(selectedDate).format('DD');
        masterData &&
          masterData.map((item) => {
            if (item.shift === Shift && item.shift === 'Morning Shift') {
              //  hours >= 6 && hours < 18)
              if (item.startHour <= startHours && endHours <= item.endHour) {
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      startDate: moment(date[0]).format('YYYY-MM-DD HH:mm'),
                      endDate: moment(date[1]).format('YYYY-MM-DD HH:mm')
                    }
                  }
                };
                props.downTimeData(formObject, false);
              } else {
                message.error(
                  'Please Select Morning Shift From' + item.startHour + '~' + item.endHour
                );
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      // startDate: moment(date[0]).format("YYYY-MM-DD HH:mm:ss"),
                      // endDate: moment(date[1]).format("YYYY-MM-DD HH:mm:ss"),
                    }
                  }
                };
              }
              props.downTimeData(formObject, false);
            } else if (
              item.shift === Shift &&
              item.shift === 'Night Shift' &&
              currentDate === startDate &&
              startDate !== endDate &&
              startTime !== endTime
            ) {
              //  hours >= 6 && hours < 18)
              if (item.startHour <= startHours && item.endHour >= endHours) {
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      startDate: moment(date[0]).format('YYYY-MM-DD HH:mm'),
                      endDate: moment(date[1]).format('YYYY-MM-DD HH:mm')
                    }
                  }
                };
              } else {
                message.error(
                  'Please Select Night Shift From' + item.startHour + '~' + item.endHour
                );
                formObject = cloneDeep(props.formObject);
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      // startDate: moment(date[0]).format("YYYY-MM-DD HH:mm:ss"),
                      // endDate: moment(date[1]).format("YYYY-MM-DD HH:mm:ss"),
                    }
                  }
                };
              }
              props.downTimeData(formObject, false);
            } else if (
              item.shift === Shift &&
              item.shift === 'Night Shift' &&
              currentDate === startDate &&
              startDate === endDate
            ) {
              if (item.startHour <= startHours && item.endHour1 >= endHours) {
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      startDate: moment(date[0]).format('YYYY-MM-DD HH:mm'),
                      endDate: moment(date[1]).format('YYYY-MM-DD HH:mm')
                    }
                  }
                };
                props.downTimeData(formObject, false);
              } else {
                message.error(
                  'Please Select Night Shift From' + item.startHour + '~' + item.endHour
                );
                formObject = cloneDeep(props.formObject);
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      // startDate: moment(date[0]).format("YYYY-MM-DD HH:mm:ss"),
                      // endDate: moment(date[1]).format("YYYY-MM-DD HH:mm:ss"),
                    }
                  }
                };
              }
            } else if (
              item.shift === Shift &&
              item.shift === 'Night Shift' &&
              currentDate !== startDate &&
              startDate === endDate
            ) {
              //  hours >= 6 && hours < 18)
              if (item.startHour2 <= startHours && item.endHour2 >= endHours) {
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      startDate: moment(date[0]).format('YYYY-MM-DD HH:mm'),
                      endDate: moment(date[1]).format('YYYY-MM-DD HH:mm')
                    }
                  }
                };
                props.downTimeData(formObject, false);
              } else {
                message.error(
                  'Please Select Night Shift From' + item.startHour + '~' + item.endHour
                );
                formObject = cloneDeep(props.formObject);
                formObject = {
                  ...formObject,
                  mainHeaderValue: {
                    ...(formObject && formObject.mainHeaderValue ? formObject.mainHeaderValue : {}),
                    [columnKey]: {
                      // startDate: moment(date[0]).format("YYYY-MM-DD HH:mm:ss"),
                      // endDate: moment(date[1]).format("YYYY-MM-DD HH:mm:ss"),
                    }
                  }
                };
              }
            }
            return {};
          });
        props.downTimeData(formObject, false);
      }
      props.downTimeData(formObject, false);
    } else {
      message.error('Please Input Start & End Times');
    }
    props.downTimeData(formObject, false);
  };

  const disabledDateRange = (formObject, current) => {
    if (
      formObject &&
      formObject['mainHeaderValue'] &&
      formObject['mainHeaderValue']['Date'] &&
      formObject['mainHeaderValue']['Shift'] === 'Morning Shift'
    ) {
      let selectedDate = moment(formObject['mainHeaderValue']['Date'], 'YYYY-MM-DD HH:mm:ss');
      return (
        current > moment(selectedDate).endOf('day') || current < moment(selectedDate).startOf('day')
      );
    } else if (
      formObject &&
      formObject['mainHeaderValue'] &&
      formObject['mainHeaderValue']['Date'] &&
      formObject['mainHeaderValue']['Shift'] === 'Night Shift'
    ) {
      //alert("1")
      let selectedDate = moment(formObject['mainHeaderValue']['Date'], 'YYYY-MM-DD HH:mm:ss');
      return (
        current > moment(selectedDate).add(1, 'day').endOf('day') ||
        current < moment(selectedDate).startOf('day')
      );
    }
    //return current > moment().add(1, 'days').endOf("day") || current < moment().startOf("day");
    return current || current > moment().endOf('day') || current < moment().startOf('day');
  };

  const renderMainSwitch = (formObj, columns) => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    switch (columns.widget) {
      case 'input':
        return (
          <Input
            style={{ width: 300 }}
            value={
              formObj && formObj.mainHeaderValue && formObj.mainHeaderValue[columns.key]
                ? formObj.mainHeaderValue[columns.key]
                : ''
            }
            placeholder={columns.placeHolder}
            onChange={(e) => onInputHeaderMainChange(e.target.value, columns.key)}
          />
        );
      case 'inputNumber':
        return (
          <InputNumber
            style={{ width: 300 }}
            value={
              formObj &&
                formObj.mainHeaderValue &&
                (formObj.mainHeaderValue[columns.key] ||
                  formObj.mainHeaderValue[columns.key] === 0)
                ? formObj.mainHeaderValue[columns.key]
                : ''
            }
            step={columns.step ? columns.step : 1}
            placeholder={columns.placeHolder}
            onChange={(e) => onInputHeaderMainChange(e, columns.key)}
          />
        );
      case 'select':
        return (
          <SelectComponent
            column={columns}
            record={{ key: columns }}
            text={
              formObj && formObj.mainHeaderValue && formObj.mainHeaderValue[columns.key]
                ? formObj.mainHeaderValue[columns.key]
                : ''
            }
            handleFieldChange={(e) => onInputHeaderMainChange(e, columns.key)}
          />
        );
      case 'date-picker':
        return (
          <DatePicker
            allowClear={false}
            showTime={columns.showTime ? columns.showTime : false}
            format={
              columns.showTime && columns.showTime === true ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
            }
            value={
              formObj &&
                formObj['mainHeaderValue'] &&
                formObj['mainHeaderValue'][columns.key]
                ? dayjs(formObj['mainHeaderValue'][columns.key], 'YYYY-MM-DD HH:mm:ss')
                : null
            }
            showNow={false}
            disabledTime={(e) => disabledRangeTime(e)}
            disabledDate={(e) =>
              disabledDatePicker(
                {
                  ...(formObj ? formObj : {})
                },
                e,
                columns.showTime
              )
            }
            onChange={(e, dateString) => onDateHeaderMainChange(dateString, columns.key)}
            style={{ width: 300 }}
          />
        );
      case 'date-pickerTime':
        return (
          <DatePicker
            allowClear={false}
            showTime={true}
            format={'YYYY-MM-DD HH:mm'}
            value={
              formObj &&
                formObj['mainHeaderValue'] &&
                formObj['mainHeaderValue'][columns.key]
                ? moment(formObj['mainHeaderValue'][columns.key], 'YYYY-MM-DD HH:mm')
                : null
            }
            disabledDate={(e) =>
              disabledDatePicker(
                {
                  ...(formObj ? formObj : {})
                },
                e
              )
            }
            onChange={(e) => onDateHeaderMainChange(e, columns.key)}
            style={{ width: 300 }}
          />
        );
      case 'dateTimeRange':
        return (
          <RangePicker
            style={{ width: 300 }}
            allowClear={false}
            showTime={{
              hideDisabledOptions: false,
              defaultValue: dateRanges(shift)
            }}
            format="YYYY-MM-DD HH:mm"
            disabledDate={(e) =>
              disabledDateRange(
                {
                  ...(formObj ? formObj : {})
                },
                e
              )
            }
            value={
              formObj &&
                formObj.mainHeaderValue &&
                formObj.mainHeaderValue &&
                formObj.mainHeaderValue[columns.key] &&
                formObj.mainHeaderValue[columns.key]['startDate'] &&
                formObj.mainHeaderValue[columns.key]['endDate']
                ? [
                  moment(formObj.mainHeaderValue[columns.key]['startDate'], dateFormat),
                  moment(formObj.mainHeaderValue[columns.key]['endDate'], dateFormat)
                ]
                : null
            }
            disabledTime={(e) => disabledRangeTime(e)}
            onOk={(e) => onMainOk(e, columns.key)}
          // onChange={(e) => onMainChange(e, columns.key)}
          />
        );
      default:
        return (
          <Input
            style={{ width: 300 }}
            value={
              formObj && formObj.mainHeaderValue && formObj.mainHeaderValue[columns.key]
                ? formObj.mainHeaderValue[columns.key]
                : ''
            }
            placeholder={columns.placeHolder}
            onChange={(e) => onInputHeaderMainChange(e.target.value, columns.key)}
          />
        );
    }
  };

  const dateRanges = (shift) => {
    switch (shift) {
      case 'daily': {
        return dailyShift;
      }
      case 'Morning Shift': {
        return morningShift;
      }
      case 'Night Shift': {
        return nightShift;
      }
      default:
        return defaultRange;
    }
  };

  const onHeaderInputChange = (columnValue, columnKey, name) => {

    let formData = {
      ...formObject,
      tabs: {
        ...(formObject && formObject.tabs ? formObject.tabs : {}),
        [name]: {
          ...(formObject && formObject.tabs && formObject.tabs[name]
            ? formObject.tabs[name]
            : {}),
          "form": {
            ...(formObject && formObject.tabs && formObject.tabs[name] && formObject.tabs[name].form
              ? formObject.tabs[name].form
              : {}),
            datasource: {
              ...(formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form &&
                formObject.tabs[name].form.datasource
                ? formObject.tabs[name].form.datasource
                : {}),
              [columnKey]: columnValue
            }
          }

        }
      }
    };

    props.downTimeData(formData, false);

  };

  const renderHeaderSwitch = (formObject, columns, name) => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    switch (columns.widget) {
      case 'input':
        return (
          <Input
            style={{ width: 300 }}
            value={
              formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form &&
                formObject.tabs[name].form.datasource &&
                formObject.tabs[name].form.datasource[columns.key]
                ? formObject.tabs[name].form.datasource[columns.key]
                : ''
            }
            placeholder={columns.placeHolder}
            onChange={(e) => onHeaderInputChange(e.target.value, columns.key, name)}
          />
        );
      case 'select':
        return (
          <SelectComponent
            column={columns}
            record={{ key: columns }}
            text={
              formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form.datasource &&
                formObject.tabs[name].form.datasource[columns.key]
                ? formObject.tabs[name].form.datasource[columns.key]
                : ''
            }
            datasource={
              formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form.datasource
                ? formObject.tabs[name].form.datasource
                : ''
            }
            handleFieldChange={(e) => onHeaderInputChange(e, columns.key, name)}
          />
        );
      case 'inputNumber':
        return (
          <InputNumber
            style={{ width: 300 }}
            value={
              formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form.datasource &&
                (formObject.tabs[name].form.datasource[columns.key] ||
                  formObject.tabs[name].form.datasource[columns.key] === 0)
                ? formObject.tabs[name].form.datasource[columns.key]
                : ''
            }
            step={columns.step ? columns.step : 1}
            // min={columns.min !== undefined ? columns.min : 0}
            // max={columns.max !== undefined ? columns.max : 1000000}
            placeholder={columns.placeHolder}
            onChange={(e) => onHeaderInputChange(e, columns.key, name)}
          />
        );
      case 'dateTimeRange':
        return (
          <RangePicker
            style={{ width: 300 }}
            // ranges={{
            //   Today: [moment(), moment()],
            //   "This Month": [
            //     moment().startOf("month"),
            //     moment().endOf("month"),
            //   ],
            // }}
            allowClear={false}
            showTime={{
              hideDisabledOptions: false,
              // defaultValue: this.dateRanges(shift)
            }}
            placeholder={['Start Time', 'End Time']}
            value={
              formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form.datasource &&
                formObject.tabs[name].form.datasource[columns.key] &&
                formObject.tabs[name].form.datasource[columns.key]['startDate'] &&
                formObject.tabs[name].form.datasource[columns.key]['endDate']
                ? [
                  moment(formObject.tabs[name].form.datasource[columns.key]['startDate'], dateFormat),
                  moment(formObject.tabs[name].form.datasource[columns.key]['endDate'], dateFormat)
                ]
                : null
            }
            format="YYYY-MM-DD HH:mm"
          // disabledTime={(e) => this.disabledRangeTime(e)}
          // onOk={(e) => this.onOk(e, columns.key, name)}
          // disabledDate={(e) =>
          //   this.disabledDateRange(
          //     {
          //       ...(formObject ? formObject : {})
          //     },
          //     e
          //   )
          // }
          />
        );
      default:
        return (
          <Input
            style={{ width: 300 }}
            value={
              formObject &&
                formObject.tabs &&
                formObject.tabs[name] &&
                formObject.tabs[name].form &&
                formObject.tabs[name].form.datasource &&
                formObject.tabs[name].form.datasource[columns.key]
                ? formObject.tabs[name].form.datasource[columns.key]
                : ''
            }
            placeholder={columns.placeHolder}
            onChange={(e) => onHeaderInputChange(e.target.value, columns.key, name)}
          />
        );
    }
  };

  const saveTableViewData = (name, e) => {
    let formData = {
      ...formObject,
      tabs: {
        ...(formObject && formObject.tabs ? formObject.tabs : {}),
        [name]: {
          ...(formObject && formObject.tabs && formObject.tabs[name]
            ? formObject.tabs[name]
            : {}),
          table: {
            ...(formObject &&
              formObject.tabs &&
              formObject.tabs[name] &&
              formObject.tabs[name].table
              ? formObject.tabs[name].table
              : {}),
            datasource: [...e]
          }
        }
      }
    };
    _.cloneDeepWith(formObject, (value) => {
      return value && value !== undefined && value !== null
        ? {
          ...value,
          ...(value['Date']
            ? (value['Date'] = moment.utc(value.InstallationDate, 'YYYY-MM-DD HH:mm:ss'))
            : null)
        }
        : null;
    });
    props.downTimeData(formData, false);
  };

  return (
    <div>

      <div>
        <Form layout="vertical">
          <div
            style={{
              ...(props.status === 'Completed'
                ? {
                  opacity: newLocal ? 0.75 : 1,
                  pointerEvents: newLocal ? 'none' : 'initial'
                }
                : {})
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                boxSizing: 'border-box'
              }}
            >
              {formObject && formObject.mainHeader
                ? formObject.mainHeader.map((mainHeaderKey, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        paddingRight: '2em',
                        ...(props.status === 'Completed'
                          ? {
                            opacity: newLocal ? 0.75 : 1,
                            pointerEvents: newLocal ? 'none' : 'initial'
                          }
                          : {})
                      }}
                    >
                      <Form.Item
                        required={false}
                        label={
                          <span style={{ marginLeft: mainHeaderKey.marginLeft }}>
                            {mainHeaderKey.displayName}
                          </span>
                        }
                      >
                        <div>{renderMainSwitch(formObject, mainHeaderKey)}</div>
                      </Form.Item>
                    </div>
                  );
                })
                : null}
            </div>
          </div>

          {formObject && formObject.tabs && Object.keys(formObject.tabs).length >= 1 ? (
            <Row style={{ marginTop: '20px' }}>
              <Collapse style={{ width: "100%" }}>
                {formObject &&
                  formObject.tabs &&
                  Object.keys(formObject.tabs).map((name) => {
                    if (name !== 'defaultData') {
                      return (
                        <Panel header={name} key={name}>
                          <div
                            style={{
                              margin: '20px 10px'
                            }}
                          >
                            <div
                              style={{
                                margin: '0px 20px',
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                boxSizing: 'border-box',
                                ...(props.status === 'Completed'
                                  ? {
                                    opacity: newLocal ? 0.75 : 1,
                                    pointerEvents: newLocal ? 'none' : 'initial'
                                  }
                                  : {})
                              }}
                            >
                              {formObject &&
                                formObject['tabs'] &&
                                formObject['tabs'][name] &&
                                formObject['tabs'][name].form &&
                                formObject['tabs'][name].form.columns
                                ? formObject['tabs'][name].form.columns.map((columns, index) => {
                                  if (columns && !columns.hide) {
                                    return (
                                      <div key={index} style={{ paddingRight: '2em' }}>
                                        <Form.Item
                                          required={false}
                                          label={
                                            <span
                                              style={{
                                                marginLeft: columns.marginLeft
                                              }}
                                            >
                                              {columns.displayName}
                                            </span>
                                          }
                                        >
                                          <div>
                                            {renderHeaderSwitch(formObject, columns, name)}
                                          </div>
                                        </Form.Item>
                                      </div>
                                    );
                                  }
                                  return {};
                                })
                                : null}
                            </div>
                            <div
                              style={{
                                ...(props.status === 'Completed'
                                  ? {
                                    opacity: newLocal ? 0.75 : 1,
                                    pointerEvents: newLocal ? 'none' : 'initial'
                                  }
                                  : {})
                              }}
                            >
                              {formObject &&
                                formObject['tabs'] &&
                                formObject['tabs'][name] &&
                                formObject['tabs'][name].table &&
                                formObject['tabs'][name].table.columns ? (
                                <TableView
                                  form={formObject['tabs'][name].table}
                                  mainHeaderValue={
                                    formObject && formObject.mainHeaderValue
                                      ? formObject.mainHeaderValue
                                      : {}
                                  }
                                  subHeaderValue={
                                    formObject &&
                                      formObject['tabs'] &&
                                      formObject['tabs'][name] &&
                                      formObject['tabs'][name].table.datasource
                                      ? formObject['tabs'][name].table.datasource
                                      : {}
                                  }
                                  recordType={'FormWithSubTabs'}
                                  saveTableViewData={(e) => saveTableViewData(name, e)}
                                />
                              ) : null}
                            </div>
                          </div>
                        </Panel>
                      );
                    }
                    return {};
                  })}
              </Collapse>
            </Row>
          ) : null}
        </Form>

      </div>
    </div>
  );
};

export default FormWithSubTabs;
